var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOpenCommunication = function SvgOpenCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#open-communication_svg__a)",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-.002 10.5c0-5.8 4.701-10.5 10.5-10.5h9.925a.25.25 0 0 1 .183.42l-2.578 2.762a10.5 10.5 0 0 1 2.38 3.837A12.419 12.419 0 0 0 19.725 7C12.947 7 7.453 12.516 7.453 19.321c0 .419.02.835.061 1.249C3.17 19.284-.002 15.262-.002 10.5Z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.726 9C14.06 9 9.453 13.614 9.453 19.322v.002a10.3 10.3 0 0 0 2.206 6.39 2 2 0 0 1-.044 2.525l-1.139 1.405h9.25C25.392 29.644 30 25.03 30 19.322 30 13.612 25.392 9 19.726 9Zm.664 12.622c0 .064-.05.113-.113.113h-1.635a.113.113 0 0 1-.113-.113c0-1.545.729-2.218 1.336-2.778.435-.401.807-.745.807-1.31 0-.717-.438-1.112-1.128-1.112-.747 0-1.24.62-1.24 1.338a.099.099 0 0 1-.099.1H16.43a.1.1 0 0 1-.1-.1c0-1.734 1.284-3.2 3.214-3.2 1.96 0 3.143 1.143 3.143 2.792 0 1.168-.615 1.745-1.209 2.303-.553.52-1.088 1.022-1.088 1.967Zm.197 2.044c0 .634-.479 1.128-1.127 1.128a1.105 1.105 0 0 1-1.128-1.128c0-.634.48-1.128 1.128-1.128.648 0 1.127.494 1.127 1.128Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "open-communication_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgOpenCommunication;